import { render, staticRenderFns } from "./LawMatterFileTypeList.vue?vue&type=template&id=3b2d5151&"
import script from "./LawMatterFileTypeList.vue?vue&type=script&lang=js&"
export * from "./LawMatterFileTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterFileTypeList.vue?vue&type=style&index=0&id=3b2d5151&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports